import reviewDetailsJson from '../../../assets/translations/review-details.json'

export const reviewDetailsContent: any = reviewDetailsJson
